const types = {
  SET_ORGANIZATIONS: 'SET_ORGANIZATIONS',
  CLEAR_ORGANIZATIONS: 'CLEAR_ORGANIZATIONS',
  SET_ACTIVE_ORGANIZATION: 'SET_ACTIVE_ORGANIZATION',
  CLEAR_ACTIVE_ORGANIZATION: 'CLEAR_ACTIVE_ORGANIZATION',
  SET_ORGANIZATION_REVS: 'SET_ORGANIZATION_REVS',
  CLEAR_ORGANIZATION_REVS: 'CLEAR_ORGANIZATION_REVS',
  SET_ORGANIZATION_REVS_COUNTER: 'SET_ORGANIZATION_REVS_COUNTER',
  CLEAR_ORGANIZATION_REVS_COUNTER: 'CLEAR_ORGANIZATION_REVS_COUNTER',
  REMOVE_ORGANIZATION_REV: 'REMOVE_ORGANIZATION_REV',
  SET_ORGANIZATION_ACCOUNTS: 'SET_ORGANIZATION_ACCOUNTS',
  CLEAR_ORGANIZATION_ACCOUNTS: 'CLEAR_ORGANIZATION_ACCOUNTS',
  ADD_ORGANIZATION_ACCOUNT: 'ADD_ORGANIZATION_ACCOUNT',
  SET_ORGANIZATION_CHALLENGES: 'SET_ORGANIZATION_CHALLENGES',
  CLEAR_ORGANIZATION_CHALLENGES: 'CLEAR_ORGANIZATION_CHALLENGES',
  SET_ORGANIZATION_CHALLENGES_COUNTER: 'SET_ORGANIZATION_CHALLENGES_COUNTER',
  CLEAR_ORGANIZATION_CHALLENGES_COUNTER:
    'CLEAR_ORGANIZATION_CHALLENGES_COUNTER',
  SET_ORGANIZATION_PAGINATOR: 'SET_ORGANIZATION_PAGINATOR',
  CLEAR_ALL_ORGANIZATION_PAGINATORS: 'CLEAR_ALL_ORGANIZATION_PAGINATORS',
  SET_ORGANIZATION_STATUS: 'SET_ORGANIZATION_STATUS',
  SET_ORGANIZATION_LOGO: 'SET_ORGANIZATION_LOGO',
  CLEAR_ORGANIZATION_LOGO: 'CLEAR_ORGANIZATION_LOGO',
  SET_ORGANIZATION_MOBILE_LOGO: 'SET_ORGANIZATION_MOBILE_LOGO',
  CLEAR_ORGANIZATION_MOBILE_LOGO: 'CLEAR_ORGANIZATION_MOBILE_LOGO',
  SET_ORGANIZATION_STRUCTURE: 'SET_ORGANIZATION_STRUCTURE',
  CLEAR_ORGANIZATION_STRUCTURE: 'CLEAR_ORGANIZATION_STRUCTURE',
  SET_ORGANIZATION_CATEGORIES: 'SET_ORGANIZATION_CATEGORIES',
  CLEAR_ORGANIZATION_CATEGORIES: 'CLEAR_ORGANIZATION_CATEGORIES',
  SET_ORGANIZATION_SITUATION_TYPES: 'SET_ORGANIZATION_SITUATION_TYPES',
  CLEAR_ORGANIZATION_SITUATION_TYPES: 'CLEAR_ORGANIZATION_SITUATION_TYPES',
  SET_ORGANIZATION_COUNTRY_CODES: 'SET_ORGANIZATION_COUNTRY_CODES',
  CLEAR_ORGANIZATION_COUNTRY_CODES: 'CLEAR_ORGANIZATION_COUNTRY_CODES',
}

export default types
